export const environment = {
  production: true,
  pusher: {
    key: '13062a0d6e29db48e87d',
    cluster: 'ap2',
  },
  baseUrl: location.protocol + '//' + location.host
};

